import React, { useEffect } from "react";
import Styles from "./WalletTable.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWalletActivities,
  clearActivities,
} from "../../../../Redux/Slices/gnaAdminSlice";
import { Skeleton } from "@mui/material";
import { convertDate, formatDateType } from "../../../../commons/FormatDate";
import {
  walletContract,
  clearWalletContract,
} from "../../../../Redux/Slices/paymentSlice";

const WalletTable = ({ fullConsumerDetails, fullGeneratorDetails }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const walletId =
    fullConsumerDetails?.walletAccount?.id ||
    fullGeneratorDetails?.walletAccount?.id;
  const activities = useSelector((state) => {
    return state?.gnaAdminSlice?.activities;
  });

  const isConsumer = !!fullConsumerDetails?.consumerId;
  const isGenerator = !!fullGeneratorDetails?.generatorId;

  const { data, loading, error } = activities || {
    data: null,
    loading: false,
    error: null,
  };

  const mainData = useSelector((state) => state?.paymentSlice);
  let contracts = mainData?.walletContract;
  // Dispatch the async thunk when walletId is available
  useEffect(() => {
    if (walletId) {
      // Clear old data first
      dispatch(clearActivities());
      // Then fetch new data
      dispatch(fetchWalletActivities({ walletId }));
    }
  }, [walletId, dispatch]);

  useEffect(() => {
    if (walletId) {
      // Clear old contracts data first
      dispatch(clearWalletContract());
      // Then fetch new data
      dispatch(walletContract({ id: walletId, page: 0, size: 10 }));
    }
  }, [dispatch, walletId]);

  const handleNav = (val) => {
    navigate(val);
  };
  return (
    <>
      <div className={`display_flex_column ${Styles.detailsMainContainer}`}>
        <div>
          <div className={`display_flex_row ${Styles.containerHeading}`}>
            <div>Contracts</div>
            <div
              className={Styles.viewAll}
              onClick={() =>
                handleNav(
                  `/wallet_contract?walletId=${walletId}&entityType=${isConsumer ? "consumer" : "generator"}`,
                )
              }
            >
              View All
            </div>
          </div>
          <div className={Styles.tableMainElem}>
            <div
              className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
            >
              <div style={{ width: "10%" }}>Contract Id</div>
              <div style={{ width: "10%" }}>Self Lisitng</div>
              <div style={{ width: "10%" }}>Counterparty</div>
              <div style={{ width: "10%" }}>Start and End Date</div>
              <div style={{ width: "10%" }}>Total Contract Value (₹)</div>
              <div style={{ width: "10%" }}>Amount Blocked (₹)</div>
              <div style={{ width: "10%" }}>Total Contract Schedule (MWH)</div>
              <div style={{ width: "10%" }}>Actual Delivery (MWH)</div>
              <div style={{ width: "10%" }}>Schedule</div>
            </div>
            <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
              {loading ? (
                Array.from({ length: 3 }).map((_, idx) => (
                  <div className="display_flex_row tableDetails" key={idx}>
                    <div style={{ width: "10%" }}></div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "20%" }}>
                      <Skeleton variant="text" width={120} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={60} height={20} />
                    </div>
                    <div style={{ width: "5%" }}>
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                  </div>
                ))
              ) : contracts?.length > 0 && contracts !== null ? (
                contracts?.map((ele) => (
                  <div className="display_flex_row tableDetails" key={ele?.id}>
                    <div style={{ width: "10%" }}>
                      {" "}
                      {ele?.bilateralContractUniqueId || "-"}
                    </div>
                    <div style={{ width: "10%" }}>
                      {(isConsumer
                        ? ele?.name?.split("-")?.[0]?.includes("C")
                          ? ele?.name?.split("-")?.[0]
                          : ele?.name?.split("-")?.[1]
                        : ele?.name?.split("-")?.[1]?.includes("G")
                          ? ele?.name?.split("-")?.[1]
                          : ele?.name?.split("-")?.[0]
                      )?.split("_")?.[0] || "-"}
                    </div>
                    <div style={{ width: "10%" }}>
                      {isConsumer
                        ? ele?.generatorName || "-"
                        : ele?.consumerName || "-"}
                    </div>
                    <div style={{ width: "10%" }}>
                      {`${formatDateType(ele?.startDate)} to ${formatDateType(
                        ele?.endDate,
                      )}`}
                    </div>
                    <div style={{ width: "10%" }}>
                      {ele?.scheduledAmount?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%" }}>
                      {(ele?.amountBlocked || 0)?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%" }}>
                      {(ele?.scheduledVolume || 0)?.toFixed(2)}
                    </div>
                    <div style={{ width: "10%" }}>
                      {(ele?.deliveredVolume || 0)?.toFixed(2)}
                    </div>
                    <div
                      style={{ width: "10%" }}
                      className={`${
                        ele?.status === "COMPLETED"
                          ? "accepted"
                          : ele?.status === "PENDING"
                            ? "pending"
                            : "rejected"
                      }`}
                    >
                      {ele?.status === "COMPLETED"
                        ? "Completed"
                        : ele?.status === "PENDING"
                          ? "Ongoing"
                          : "Rejected"}
                    </div>
                  </div>
                ))
              ) : (
                <div className={Styles.noData}>No contracts available</div>
              )}
            </div>
          </div>
        </div>
        <div>
          <div className={`display_flex_row ${Styles.containerHeading}`}>
            <div>Transactions</div>
            <div
              className={Styles.viewAll}
              onClick={() =>
                handleNav(`/wallet_transaction?walletId=${walletId}`)
              }
            >
              View All
            </div>
          </div>
          <div className={Styles.tableMainElem}>
            <div
              className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
            >
              <div style={{ width: "15%" }}>Self Listing</div>
              <div style={{ width: "15%" }}>Counterparty Name</div>
              <div style={{ width: "15%" }}>Contract Id</div>
              <div style={{ width: "15%" }}>Transaction Date</div>
              <div style={{ width: "15%" }}>Transaction Amount (₹)</div>
              <div style={{ width: "10%" }}>Type</div>
              <div style={{ width: "10%" }}>Action</div>
              {/* <div style={{ width: "35%" }}>Comments</div> */}
            </div>
            <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
              {loading ? (
                Array.from({ length: 3 }).map((_, idx) => (
                  <div className="display_flex_row tableDetails" key={idx}>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={30} height={20} />
                    </div>
                    <div style={{ width: "20%" }}>
                      <Skeleton variant="text" width={100} height={20} />
                    </div>
                    <div style={{ width: "20%" }}>
                      <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width={40} height={20} />
                    </div>
                    <div style={{ width: "35%" }}>
                      <Skeleton variant="text" width={120} height={20} />
                    </div>
                  </div>
                ))
              ) : data?.length > 0 ? (
                data?.map((ele, index) => (
                  <div
                    className="display_flex_row tableDetails"
                    key={ele?.id || index}
                  >
                    <div style={{ width: "15%" }}>
                      {ele?.listingId?.split("_")?.[0] || "-"}
                    </div>
                    <div style={{ width: "15%" }}>
                      <div>
                        {(ele?.counterPartyName === "UNKNOWN"
                          ? ""
                          : ele?.counterPartyName) || "-"}
                      </div>
                      {ele?.counterPartyListingId && (
                        <div style={{ fontSize: "8px" }}>
                          {ele?.counterPartyListingId || "-"}
                        </div>
                      )}
                    </div>
                    <div style={{ width: "15%" }}>
                      {ele?.bilateralContractUniqueId || "Not Generated"}
                    </div>
                    <div style={{ width: "15%" }}>
                      {convertDate(ele?.dateTime?.split(" ")?.[0])} <br />
                      {ele?.dateTime?.split(" ")?.[1]}
                    </div>
                    <div style={{ width: "15%" }}>
                      {ele?.amount?.toFixed(2)}
                    </div>
                    <div
                      style={{
                        width: "10%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {ele?.paymentType?.split("_")?.join(" ") || "-"}
                    </div>
                    <div
                      style={{ width: "10%" }}
                      className={
                        ele?.activity === "CREDIT" ||
                        ele?.activity === "RELEASED"
                          ? "accepted"
                          : "rejected"
                      }
                    >
                      {ele?.activity}
                    </div>
                  </div>
                ))
              ) : (
                <div className={Styles.noData}>No transactions available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletTable;
